import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "exclamation",
  "use": "exclamation-usage",
  "viewBox": "0 0 3 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 3 10\" id=\"exclamation\">\n  <path fill-rule=\"evenodd\" d=\"M333.364,192.57h-1.728a0.409,0.409,0,0,0-.3.132,0.427,0.427,0,0,0-.129.31v1.546a0.429,0.429,0,0,0,.129.311,0.412,0.412,0,0,0,.3.131h1.728a0.414,0.414,0,0,0,.3-0.131,0.432,0.432,0,0,0,.128-0.311v-1.546a0.43,0.43,0,0,0-.128-0.31,0.411,0.411,0,0,0-.3-0.132h0Zm0,0,0.516-7.44a0.4,0.4,0,0,0-.3-0.131h-2.16a0.4,0.4,0,0,0-.3.131,0.415,0.415,0,0,0-.118.311l0.189,5.3a0.451,0.451,0,0,0,.138.31,0.423,0.423,0,0,0,.308.132h1.728a0.42,0.42,0,0,0,.307-0.132,0.448,0.448,0,0,0,.139-0.31l0.188-5.3a0.408,0.408,0,0,0-.118-0.311h0Zm0,0\" transform=\"translate(-331 -185)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/exclamation.svg
// module id = null
// module chunks = 